module.exports = __webpack_public_path__ + "static/cookpad@2x-f3293bd476116497a90399a136bb74c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/customer-stories/cookpad@2x.jpg
// module id = 866
// module chunks = 33019919093843 122353984331245